import { Spinner } from "components/Spinner/Spinner"
import { ReactNode } from "react"
import { cn } from "styles/cn"

export function Feedback({
	spinning,
	className,
	children,
}: {
	spinning: boolean
	className?: string
	children?: ReactNode
}) {
	return spinning ? (
		<div className="grid">
			<div
				className="pointer-events-none col-start-1 row-start-1 size-full opacity-30"
				inert
			>
				{children}
			</div>
			<div
				className={cn(
					"col-start-1 row-start-1 flex size-full flex-col items-center justify-center gap-2 rounded-2xl bg-mint-0 p-6",
					className,
				)}
			>
				<Spinner spinning={spinning} size="large" percent="auto" />
			</div>
		</div>
	) : (
		children
	)
}
